export const STORAGE_KEY_AUTH = "auth_token";
export const STORAGE_KEY_USER_AUTH = "user_auth_token";

export const API_BASE_URL = "https://ratem.evetws.com/ratem";
export const API_SMS_VALIDATION = "/Login/Auth";
export const API_GET_BRANCHES = "/Ratem/GetBranches";
export const API_VALIDATE_ACCOUNT = "/login/ValidateAccount";
export const API_SAVE_ACCOUNT = "/Ratem/SaveAccount";
export const API_AUTH_ME = "/login/Auth/Me";
export const GET_ANIMAL_BREEDS = "/Ratem/GetBreeds";
export const GET_DISTRICT_BY_TOWN = "/Ratem/GetDistrictByCountry";
export const GET_ANIMAL_OWNERS = "/Ratem/GetAnimalOwners";
export const GET_ANIMAL_BY_OWNER_ID = "/Ratem/getAnimalByOwnerId";
export const GET_ANIMAL_TYPES = "/Ratem/GetAnimalTypes";
export const GET_ANIMAL_GENDERS = "/Ratem/GetGenders";
export const GET_ADDRESS_INFO = "/Ratem/GetAddressInfo";
export const GET_TEST_GROUPS = "/Ratem/GetTestGroups";
export const API_SAVE_REQUEST = "/Ratem/SaveRequest";
export const GET_REQUEST_LIST = "/Ratem/getRequestList";
export const API_DOWNLOAD_FILE = "/Ratem/DownloadFile";
export const GET_RESULT_URL = "/Ratem/GetResultUrl";
export const GET_OWNER_WITH_ANIMALS = "/Ratem/getOwnerWithAnimalsDTO";
export const API_VALIDATE_CUSTOMER = "/Login/ValidateCustomer";
export const API_AUTH_CUSTOMER = "/Login/AuthCustomer";
export const GET_RESULT_LIST = "/Ratem/getResultList";
export const GET_CUSTOMER_RESULTS = "/Ratem/getCustomerResults";
export const GET_CUSTOMER_APPOINTMENTS = "/Ratem/getCustomerAppointments";
export const GET_APPOINTMENT_STATUS = "/Ratem/GetApointmentStatuses";
export const UPDATE_REQUESTS = "/Ratem/UpdateRequest";
export const GET_REQUEST_BY_ID = "/Ratem/getRequestById";
export const GET_RATEM_ALL_REQUESTS = "/Ratem/getRatemRequestList";
export const CANCEL_REQUEST = "/Ratem/CancelRequest";
export const ADMIN_INSPECT = "/Login/ValidateAccountInspect";
export const ADMIN_INSPECT_CUSTOMER = "/Login/ValidateCustomInspect";
export const ADMIN_AUTH_EVET_LOGIN = "/Login/AuthCustomer";

export const API_URL_BASE_RECAPTCHA_SERVICE = "https://recaptcha.evetws.com";
export const API_URL_RECAPTCHA_VERIFY = `${API_URL_BASE_RECAPTCHA_SERVICE}/token/verify`;
